import { Typography } from '@mui/material';
import { type ScreeningResultOption } from './types';
import { ScreeningResult } from './constants';

export const staticSmbScreeningResultsOptions: ScreeningResultOption[] = [
  {
    id: 'low',
    text: 'Low Coverage',
    subText: '2 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResult.Approved,
  },
  {
    id: 'medium',
    text: 'Medium Coverage',
    subText: '6 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResult.ApprovedWithConditions,
  },
  {
    id: 'max',
    text: 'Max Coverage',
    subText: '12 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResult.Denied,
  },
];

export const staticInstitutionalScreeningResultsOptions: ScreeningResultOption[] = [
  {
    id: 'approved',
    text: 'Approved',
    value: ScreeningResult.Approved,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who qualify for a lease and would like to replace their security deposit.
      </Typography>
    ),
  },
  {
    id: 'conditional',
    text: 'Approved with Conditions',
    value: ScreeningResult.ApprovedWithConditions,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who are replacing a larger security deposit, or need TheGuarantors uniform homes to
        help them qualify for the lease.
      </Typography>
    ),
  },
  {
    id: 'denied',
    text: 'Denied',
    value: ScreeningResult.Denied,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who need TheGuarantors to help them qualify for the lease.
      </Typography>
    ),
  },
];
